import {
  hideButton,
  showButton,
  loadImage
} from '../utilities'
export function otherCoversModal (covers) {
// product image modal
  let productImageModal = null
  const productImageModalArray = []
  let productImageModalBtns = null
  let productImageModalImageHolder = null
  let productImageModalBtnsNext = null
  let productImageModalBtnsPrev = null
  let productImageModalPreloader = null
  let loadNextModalImage = null

  covers.forEach((otherCover, index) => {
    // Init image popup modal if first image
    if (index === 0) {
      new window.theme.Modals('ProductImageModal', 'product-image-modal')
      productImageModal = document.querySelector('.js-supadu-product-image-modal')
      productImageModalImageHolder = productImageModal.querySelector(
        '.js-product-image-modal-image-holder'
      )
      productImageModalBtns = productImageModal.querySelectorAll(
        '.js-image-modal-button'
      )
      productImageModalBtnsNext = productImageModal.querySelectorAll(
        '.js-image-modal-button.js-image-modal-button--next'
      )[0]
      productImageModalBtnsPrev = productImageModal.querySelectorAll(
        '.js-image-modal-button.js-image-modal-button--prev'
      )[0]
      productImageModalPreloader = productImageModal.querySelectorAll(
        '.js-product-image-modal-preloader'
      )[0]
      loadNextModalImage = (imgSrc) => {
        productImageModalImageHolder.classList.add('is-loading')
        productImageModalPreloader.classList.add('is-active')
        loadImage(imgSrc).then((img) => {
          setTimeout(() => {
            productImageModalImageHolder.classList.remove('is-loading')
            productImageModalPreloader.classList.remove('is-active')
            productImageModalImageHolder.innerHTML = ''
            productImageModalImageHolder.insertAdjacentElement(
              'beforeend',
              img
            )
          }, 500)
        })
      }

      productImageModalBtns.forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault()
          let targetElement = e.target
          // fix for click on arrow image and not button
          if (e.target.tagName === 'IMG') {
            targetElement = e.target.parentElement
          }
          if (
            targetElement.classList.contains('js-image-modal-button--next') &&
          productImageModal.dataset.imageIndex <
          productImageModalArray.length - 1
          ) {
            productImageModal.dataset.imageIndex++

            loadNextModalImage(
              productImageModalArray[productImageModal.dataset.imageIndex]
            )
          } else if (
            targetElement.classList.contains('js-image-modal-button--prev') &&
          productImageModal.dataset.imageIndex > 0
          ) {
            productImageModal.dataset.imageIndex--

            loadNextModalImage(
              productImageModalArray[productImageModal.dataset.imageIndex]
            )
          }

          // disable/enabled next and previous buttons
          if (
            productImageModal.dataset.imageIndex ==
          productImageModalArray.length - 1
          ) {
            hideButton(productImageModalBtnsNext)
          } else {
            showButton(productImageModalBtnsNext)
          }
          if (productImageModal.dataset.imageIndex == 0) {
            hideButton(productImageModalBtnsPrev)
          } else {
            showButton(productImageModalBtnsPrev)
          }
        })
      })
      /**
     * re-enable buttons after modal close
     * $/jQuery defined in theme.js.liquid, so eslint ignored
     */
      // eslint-disable-next-line
    $('body').on('modalClose.ProductImageModal', function (event) {
        showButton(productImageModalBtnsNext)
        showButton(productImageModalBtnsPrev)
      })
    }

    // add image to array
    productImageModalArray.push(otherCover.src.replace('w=145', 'w=1400'))

    otherCover.addEventListener('click', (e) => {
      const newSrc = e.currentTarget.src.replace('w=145', 'w=1400')
      productImageModal.dataset.imageIndex = productImageModalArray.findIndex(
        (imgSrc) => newSrc === imgSrc
      )
      document.querySelector('.js-image-holder').innerHTML = `<img src="${productImageModalArray[productImageModal.dataset.imageIndex]
      }">`
      // disable/enabled buttons
      if (
        productImageModal.dataset.imageIndex ==
      productImageModalArray.length - 1
      ) {
        hideButton(productImageModalBtnsNext)
      }
      if (productImageModal.dataset.imageIndex == 0) {
        hideButton(productImageModalBtnsPrev)
      }
    })
  })
}
